import React, { useEffect, useState } from "react";
import { discoveryMenu, experience } from "../data";
import { Link } from "react-router-dom";
import { FaExternalLinkAlt } from "react-icons/fa";
import { motion } from "framer-motion";

const Front = () => {
  const frontVariants = {
    hidden: { opacity: 0, y: -20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        delay: 0.3,
        when: "beforeChildren",
      },
    },
  };

  return (
    <section className="home-center">
      <motion.div
        className="front"
        variants={frontVariants}
        initial="hidden"
        animate="visible"
      >
        <div className="front-icon"></div>
        <div className="front-texts">
          <h1>Discover my Amazing Art Space</h1>
          <p>
            <span>{"<"}</span>
            <span className="span">code</span>
            <span>{">"}</span> <code>I build</code> <span>{"</"}</span>
            <span className="span">code</span>
            <span>{">"}</span>
          </p>
          <div className="btns-div">
            <button className="explore-btn">
              <Link to="./projects">Explore Now</Link>
            </button>
            <button className="explore-btn hire-btn">
              <Link to="./contact">want to hire me?</Link>
            </button>
          </div>
        </div>
      </motion.div>
      {/* ----------------- */}
      <div className="front-display">
        {experience.map((s, index) => (
          <motion.h1
            key={index}
            initial={{ opacity: 0, x: -10 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: s.dly + 0.3 }}
          >
            {s.num}
            <span>{s.txt}</span>
          </motion.h1>
        ))}
      </div>
      {/* ----------------- */}
      <div className="discovery">
        <h1>Discover More</h1>
        <div className="boxes">
          {discoveryMenu.map((menu, index) => {
            const { name, img, text, url, urlText, animDelay } = menu;
            return (
              <motion.div
                key={index}
                className="box"
                style={{ background: `url(/${img})` }}
                initial={{ opacity: 0.2, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{
                  delay: animDelay,
                  duration: 1,
                  when: "beforeChildren",
                }}
              >
                <motion.div
                  className="box-content"
                  initial={{ x: "-100%", opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  transition={{ delay: animDelay + 0.2, duration: 1 }}
                >
                  <h5>{name}</h5>
                  <Link to={url}>
                    {urlText} <FaExternalLinkAlt />
                  </Link>
                  <p>{text}</p>
                </motion.div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Front;
